export const facilitiesList = [
  "Pago con tarjeta",
  "Zona de parking",
  "zona de parking gratuito",
  "Valet parking",
  "Zona infantil",
  "Zona al aire libre",
  "Música en vivo",
  "Wi-Fi",
  "Pantalla para eventos deportivos",
  "Eventos especiales",
  "vista panorámica",
  "Cocina en vivo",
  "Conectores de carga en mesas",
];
